
export default {
    namespaced: true,
    state: {
        dialog: false,
        grupos: [],
        grupo: {},
        editandoGrupo: ''
    },
    mutations: {
        SET_DIALOG(state, mostrar){
            state.dialog = mostrar
        },
        SET_GRUPOS(state, respuesta){
            state.grupos = [];
            let grupos = [];
            respuesta.data.forEach(grupo => {
                let estado = grupo.habilitado ? 'Habilitado' : 'Deshabilitado';
                grupos.push({
                    id: grupo.id,
                    nombre: grupo.nombreGrupo,
                    fechaCreacion: grupo.created_at ,
                    estado: estado
                });
            });
            state.grupos = grupos;
        },
        SET_GRUPO(state, grupo){
            //console.log(grupos);
            state.editandoGrupo = true;
            state.grupo = grupo;
        },
        SET_NUEVOGRUPO(state){
            state.editandoGrupo = false;
            state.grupo = {
                nombreGrupo: '',
                observaciones: '',
                IpsConfianza: '*',
                habilitado: 1,
                user: [],
                componentes: []
            }
        }
    },
    actions: {
        setDialog({commit}, mostrar){
            commit('SET_DIALOG', mostrar);
        },
        setGrupos({commit}, respuesta){
            commit('SET_GRUPOS', respuesta);
        },
        setGrupo({commit}, grupo){
            commit('SET_GRUPO', grupo);
        },
        setNuevoGrupo({commit}){
            commit('SET_NUEVOGRUPO');
        }
    }
}